var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view", attrs: { id: "booking-tree-grid" } },
    [
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c(
            "search-item",
            {
              ref: _vm.searchItemConfigModule,
              staticStyle: { "margin-top": "0" },
              attrs: {
                "config-module": _vm.searchItemConfigModule,
                "is-collapse-list": !_vm.isFba,
                "grid-options": _vm.gridOptions,
                "grid-config-module": _vm.isFba ? "10010" : "130001",
                "is-append-query": true,
                reset: true,
                "custom-search-items": _vm.customSearchItems,
                "custom-sim-query-placeholder": _vm.$t(
                  "Message.QuickSearchBusinessNo"
                ),
                "record-expand-status": true,
                "input-enter-query": true
              },
              on: {
                "click-more": function(value) {
                  return (_vm.isAdvancedQuery = value)
                },
                keyWordCharge: _vm.keyWordCharge,
                simSearchItemCallBack: _vm.toSimpleQuery,
                advSearchItemCallBack: _vm.toAdvancedQuery,
                perConfigChange: function(value) {
                  _vm.perConfigName = value
                },
                refreshGrid: function() {
                  _vm.gridRefreshId += 1
                },
                defaultSearchItemsChange: function(value) {
                  _vm.defaultSearchItems = value
                }
              }
            },
            [
              _c(
                "template",
                { slot: "operations" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "look",
                        disabled:
                          !_vm.selectedJob ||
                          _vm.total <= 0 ||
                          _vm.hqDisabledViewDetail ||
                          (!_vm.isHQ && !_vm.validSingleSelect) ||
                          _vm.hierarchyDisabledViewDetail,
                        type: "success"
                      },
                      on: {
                        click: function($event) {
                          return _vm.toLook()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.look")) + " ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "edit",
                        disabled:
                          !(
                            _vm.selectedJob &&
                            Number(_vm.selectedJob.jobState) === 0 &&
                            !_vm.JobUtils.isBlockJob(_vm.selectedJob)
                          ) ||
                          !_vm.validSingleSelect ||
                          !_vm.hierarchyValidSingleSelect,
                        type: "success"
                      },
                      on: {
                        click: function($event) {
                          return _vm.toEdit()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.edit")) + " ")]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.$checkPermission([
                              "button_SEBooking_addSEBooking"
                            ]) &&
                            !_vm.$checkPermission([
                              "button_Job_importOrderExcel"
                            ]),
                          expression:
                            "$checkPermission(['button_SEBooking_addSEBooking']) && !$checkPermission(['button_Job_importOrderExcel'])"
                        }
                      ],
                      staticStyle: { "margin-right": "5px" },
                      attrs: {
                        no: "new",
                        disabled: _vm.hqDisabledOperate,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.toAdd()
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common.btn.new")) + " ")]
                  ),
                  _c(
                    "el-dropdown",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.$checkPermission([
                              "button_SEBooking_addSEBooking"
                            ]) &&
                            _vm.$checkPermission([
                              "button_Job_importOrderExcel"
                            ]),
                          expression:
                            "$checkPermission(['button_SEBooking_addSEBooking']) && $checkPermission(['button_Job_importOrderExcel'])"
                        }
                      ],
                      staticStyle: { margin: "0 5px" },
                      attrs: {
                        no: "exportOrderHandle",
                        "split-button": "",
                        type: "primary",
                        disabled: _vm.hqDisabledOperate
                      },
                      on: {
                        click: function($event) {
                          return _vm.exportOrderHandle()
                        },
                        command: function(p) {
                          _vm.exportOrderCommand = p
                          _vm.exportOrderHandle()
                        }
                      }
                    },
                    [
                      _vm.exportOrderCommand ===
                      _vm.$t("SeaExport.TemplateDownload")
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("CargoMsg.Cargo_DownImportTemplate")
                              )
                            )
                          ])
                        : _vm.exportOrderCommand !== _vm.$t("SeaExport.import")
                        ? _c("span", [_vm._v(_vm._s(_vm.exportOrderCommand))])
                        : _vm._e(),
                      _vm.exportOrderCommand === _vm.$t("SeaExport.import")
                        ? _c(
                            "el-upload",
                            {
                              staticStyle: {
                                display: "inline-block",
                                "margin-left": "5px"
                              },
                              attrs: {
                                action: _vm.URL.sys.importOrderTemplate,
                                headers: _vm.headers,
                                "show-file-list": false,
                                accept: ".xls, .xlsx",
                                "before-upload": _vm.beforeOrderUpload,
                                "on-success": _vm.uploadOrderSuccess,
                                "on-error": _vm.handleError,
                                data: {
                                  branchId: _vm.$store.getters.currentOfficeId,
                                  lob: "SE"
                                }
                              }
                            },
                            [
                              _c("span", { staticStyle: { color: "white" } }, [
                                _vm._v(_vm._s(_vm.$t("SeaExport.import")))
                              ])
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [
                          _c(
                            "el-dropdown-item",
                            { attrs: { command: _vm.$t("SeaExport.Add") } },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("SeaExport.Add")) + " "
                              )
                            ]
                          ),
                          !_vm.isFba
                            ? _c(
                                "el-dropdown-item",
                                {
                                  attrs: { command: _vm.$t("SeaExport.import") }
                                },
                                [
                                  _c(
                                    "el-upload",
                                    {
                                      ref: "uploadOrder",
                                      staticStyle: { display: "inline-block" },
                                      attrs: {
                                        action: _vm.URL.sys.importOrderTemplate,
                                        headers: _vm.headers,
                                        "show-file-list": false,
                                        accept: ".xls, .xlsx",
                                        "before-upload": _vm.beforeOrderUpload,
                                        "on-success": _vm.uploadOrderSuccess,
                                        "on-error": _vm.handleError,
                                        data: {
                                          branchId:
                                            _vm.$store.getters.currentOfficeId,
                                          lob: "SE"
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: {
                                            "padding-left": "0px",
                                            color: "#6F6F6F",
                                            "text-align": "left",
                                            width: "80px"
                                          },
                                          attrs: {
                                            slot: "trigger",
                                            type: "text"
                                          },
                                          slot: "trigger"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("SeaExport.import"))
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.isFba
                            ? _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.$t(
                                      "SeaExport.TemplateDownload"
                                    )
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "CargoMsg.Cargo_DownImportTemplate"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.isFba &&
                          _vm.$checkPermission([
                            "button_FBABookingNew_addSeaFbaOrder"
                          ])
                            ? _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.$t("FbaJob.batchImportOrder")
                                  }
                                },
                                [
                                  _c(
                                    "el-upload",
                                    {
                                      ref: "uploadBatchOrder",
                                      staticStyle: { display: "inline-block" },
                                      attrs: {
                                        action:
                                          _vm.URL.seaExport.batchImportFbaJob,
                                        headers: _vm.headers,
                                        "show-file-list": false,
                                        accept: ".xls, .xlsx",
                                        "before-upload": _vm.beforeOrderUpload,
                                        "on-success": _vm.uploadOrderSuccess,
                                        "on-error": _vm.handleError,
                                        data: {
                                          branchId:
                                            _vm.$store.getters.currentOfficeId,
                                          deptId:
                                            _vm.$store.getters.currentDeptId,
                                          lob: "FBA_SE"
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: {
                                            "padding-left": "0px",
                                            color: "#6F6F6F",
                                            "text-align": "left",
                                            width: "80px"
                                          },
                                          attrs: {
                                            slot: "trigger",
                                            type: "text"
                                          },
                                          slot: "trigger"
                                        },
                                        [
                                          _c("span", [
                                            _c("img", {
                                              attrs: {
                                                src: require("@/assets/fba-import.png")
                                              }
                                            })
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "FbaJob.batchImportOrder"
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.isFba &&
                          _vm.$checkPermission([
                            "button_FBABookingNew_addSeaFbaOrder"
                          ])
                            ? _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.$t(
                                      "CargoMsg.Cargo_DownImportTemplate"
                                    )
                                  }
                                },
                                [
                                  _c("span", [
                                    _c("img", {
                                      attrs: {
                                        src: require("@/assets/fba-download.png")
                                      }
                                    })
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "FbaJob.downloadBatchImportTemplate"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.isFba &&
                          _vm.$checkPermission([
                            "button_FBABookingNew_addSeaFbaOrder"
                          ])
                            ? _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.$t("FbaJob.importSingleOrder")
                                  }
                                },
                                [
                                  _c(
                                    "el-upload",
                                    {
                                      ref: "uploadSingleOrder",
                                      staticStyle: { display: "inline-block" },
                                      attrs: {
                                        action:
                                          _vm.URL.seaExport
                                            .importBatchSeaFirstSimple,
                                        headers: _vm.headers,
                                        "show-file-list": false,
                                        accept: ".xls, .xlsx",
                                        "before-upload": _vm.beforeOrderUpload,
                                        "on-success":
                                          _vm.uploadOrderSuccessSimple,
                                        "on-error": _vm.handleError,
                                        data: {
                                          officeId:
                                            _vm.$store.getters.currentOfficeId,
                                          deptId:
                                            _vm.$store.getters.currentDeptId
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: {
                                            "padding-left": "0px",
                                            color: "#6F6F6F",
                                            "text-align": "left",
                                            width: "80px"
                                          },
                                          attrs: {
                                            slot: "trigger",
                                            type: "text"
                                          },
                                          slot: "trigger"
                                        },
                                        [
                                          _c("span", [
                                            _c("img", {
                                              attrs: {
                                                src: require("@/assets/fba-import.png")
                                              }
                                            })
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "FbaJob.importSingleOrder"
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.isFba &&
                          _vm.$checkPermission([
                            "button_FBABookingNew_addSeaFbaOrder"
                          ])
                            ? _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.$t(
                                      "CargoMsg.Cargo_DownImportTemplate_Simple"
                                    )
                                  }
                                },
                                [
                                  _c("span", [
                                    _c("img", {
                                      attrs: {
                                        src: require("@/assets/fba-download.png")
                                      }
                                    })
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "FbaJob.downloadSingleImportTemplate"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_SEBooking_addLCL"
                          ]),
                          expression:
                            "$checkPermission(['button_SEBooking_addLCL'])"
                        }
                      ],
                      attrs: {
                        no: "AddHbl",
                        type: "primary",
                        disabled: _vm.hqDisabledOperate
                      },
                      on: {
                        click: function($event) {
                          return _vm.toAdd({ masterFlag: true })
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.AddHbl")) + " ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "SplitHbl",
                        type: "primary",
                        disabled:
                          !_vm.btnInfo.enableBtnSplit ||
                          !_vm.validMultipleSelect
                      },
                      on: {
                        click: function($event) {
                          return _vm.toSplit()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.SplitHbl")) + " ")]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_SEBooking_addSEBooking"
                          ]),
                          expression:
                            "$checkPermission(['button_SEBooking_addSEBooking'])"
                        }
                      ],
                      attrs: {
                        no: "Clone",
                        type: "primary",
                        disabled:
                          !_vm.validMultipleSelect ||
                          !_vm.hierarchyValidMultipleSelect
                      },
                      on: {
                        click: function($event) {
                          return _vm.toCopy()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Clone")) + " ")]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission(["button_deleteJob"]),
                          expression: "$checkPermission(['button_deleteJob'])"
                        }
                      ],
                      attrs: {
                        no: "Delete",
                        type: "danger",
                        disabled: !_vm.validMultipleSelect
                      },
                      on: {
                        click: function($event) {
                          return _vm.toDelete()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")) + " ")]
                  ),
                  _vm.isHc
                    ? _c(
                        "el-dropdown",
                        {
                          staticStyle: { margin: "0 5px" },
                          attrs: {
                            no: "priceAuditHandle",
                            "split-button": "",
                            type: "primary",
                            disabled: !_vm.selectedJob || _vm.total <= 0
                          },
                          on: {
                            click: _vm.priceAuditHandle,
                            command: function(p) {
                              _vm.priceAuditCommand = p
                              _vm.priceAuditHandle()
                            }
                          }
                        },
                        [
                          _vm._v(" " + _vm._s(_vm.priceAuditCommand) + " "),
                          _c(
                            "el-dropdown-menu",
                            { attrs: { slot: "dropdown" }, slot: "dropdown" },
                            [
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.$t(
                                      "CargoMsg.Cargo_preportAudit"
                                    )
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_preportAudit")
                                    ) + " "
                                  )
                                ]
                              ),
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.$t(
                                      "CargoMsg.Cargo_TailEndAudit"
                                    )
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_TailEndAudit")
                                    ) + " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  !(
                    _vm.$checkPermission(["role_hideAllExports"]) &&
                    !_vm.$store.getters.isAdmin
                  )
                    ? _c(
                        "el-dropdown",
                        {
                          staticStyle: { margin: "0 5px" },
                          attrs: {
                            no: "exportHandle",
                            "split-button": "",
                            type: "primary",
                            disabled: !_vm.validMultipleSelect
                          },
                          on: {
                            click: function($event) {
                              return _vm.exportHandle()
                            },
                            command: function(p) {
                              _vm.exportCommand = p
                              _vm.exportHandle()
                            }
                          }
                        },
                        [
                          _vm._v(" " + _vm._s(_vm.exportCommand) + " "),
                          _c(
                            "el-dropdown-menu",
                            { attrs: { slot: "dropdown" }, slot: "dropdown" },
                            [
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.$t("SeaExport.ExportToExcel")
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.ExportToExcel")) +
                                      " "
                                  )
                                ]
                              ),
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.$t(
                                      "SeaExport.OverseasAgentEDI"
                                    )
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.OverseasAgentEDI")
                                    ) + " "
                                  )
                                ]
                              ),
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.$t(
                                      "SeaExport.ExportWithSOPToExcel"
                                    )
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.ExportWithSOPToExcel")
                                    ) + " "
                                  )
                                ]
                              ),
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.$t("SeaExport.ExportAgentList")
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.ExportAgentList")
                                    ) + " "
                                  )
                                ]
                              ),
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    disabled: !_vm.$checkPermission([
                                      "button_JobBooking_BatchExportCustoms"
                                    ]),
                                    command: _vm.$t(
                                      "CargoMsg.Cargo_ExportCustomsDeclaration"
                                    )
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_ExportCustomsDeclaration"
                                      )
                                    ) + " "
                                  )
                                ]
                              ),
                              _vm.poItemsTabViewModel
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "el-dropdown-item",
                                        { attrs: { command: "PACK SLIP" } },
                                        [_vm._v(" PACK SLIP ")]
                                      ),
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          attrs: { command: "Shipment Report" }
                                        },
                                        [_vm._v(" Shipment Report ")]
                                      ),
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          attrs: {
                                            command: "Weekly Loading Plan"
                                          }
                                        },
                                        [_vm._v(" Weekly Loading Plan ")]
                                      ),
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          attrs: {
                                            command: _vm.$t(
                                              "SeaExport.WarehousingFee"
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "SeaExport.WarehousingFee"
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          attrs: {
                                            command: "Fcl Shipment Report"
                                          }
                                        },
                                        [_vm._v(" Fcl Shipment Report ")]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        disabled: !_vm.validMultipleSelect
                      },
                      on: { click: _vm.editState }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.EditSopStatus")))]
                  ),
                  _c(
                    "el-dropdown",
                    {
                      staticStyle: { margin: "0 5px", "font-size": "12px" },
                      attrs: {
                        no: "batchHandle",
                        disabled: !_vm.validMultipleSelect
                      },
                      on: { command: _vm.batchHandle }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            disabled:
                              !_vm.btnInfo.batchSelectFlag ||
                              !_vm.validMultipleSelect
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("SeaExport.BatchProcessing")) +
                              " "
                          ),
                          _c("i", {
                            staticClass: "el-icon-arrow-down el-icon--right"
                          })
                        ]
                      ),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                disabled: !_vm.$checkPermission([
                                  "button_JobBooking_BatchShutOut"
                                ]),
                                command: 1
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.BatchShutOut")) + " "
                              )
                            ]
                          ),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                disabled: !_vm.$checkPermission([
                                  "button_JobBooking_BatchCommit"
                                ]),
                                command: 2
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.BatchCommit")) + " "
                              )
                            ]
                          ),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                disabled: !_vm.$checkPermission([
                                  "button_JobBooking_BatchPerCommit"
                                ]),
                                command: 3
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.BatchPreSubmission")) +
                                  " "
                              )
                            ]
                          ),
                          _vm.$checkPermission([
                            "button_JobBooking_BatchManagerSubmission"
                          ])
                            ? _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    disabled: !_vm.$checkPermission([
                                      "button_JobBooking_BatchManagerSubmission"
                                    ]),
                                    command: 9
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.BatchManagerSubmission")
                                    ) + " "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                disabled: !_vm.$checkPermission([
                                  "button_SEBooking_batchVessel"
                                ]),
                                command: 4
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.BatchVessel")) + " "
                              )
                            ]
                          ),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                disabled: !_vm.$checkPermission([
                                  "button_SEBooking_BatchUpdateJobInfo"
                                ]),
                                command: 17
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.BatchModifyBusiness"))
                              )
                            ]
                          ),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                disabled: !_vm.$checkPermission([
                                  "button_SEBooking_batchUpdateType"
                                ]),
                                command: 5
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.BatchUpdateType")) +
                                  " "
                              )
                            ]
                          ),
                          _vm.$checkPermission([
                            "button_JobBooking_ReturnToOperater"
                          ])
                            ? _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    disabled: !_vm.$checkPermission([
                                      "button_SEBooking_cancelProfit"
                                    ]),
                                    command: 11
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "SeaExport.BatchReturnPreSubmission"
                                      )
                                    ) + " "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.$checkPermission([
                            "button_SEBooking_BatchReturnSubmit"
                          ])
                            ? _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    disabled: !_vm.$checkPermission([
                                      "button_SEBooking_BatchReturnSubmit"
                                    ]),
                                    command: 6
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.BatchReturnSubmit")
                                    ) + " "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.$checkPermission([
                            "button_SEBooking_BatchUpdateScNo"
                          ])
                            ? _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    disabled: !_vm.$checkPermission([
                                      "button_SEBooking_BatchUpdateScNo"
                                    ]),
                                    command: 7
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.BatchUpdateScNo")
                                    ) + " "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.$checkPermission([
                            "button_SEBooking_BatchUpdateCustomJobType"
                          ])
                            ? _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    disabled: !_vm.$checkPermission([
                                      "button_SEBooking_BatchUpdateCustomJobType"
                                    ]),
                                    command: 8
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "SeaExport.BatchUpdateCustomJobType"
                                      )
                                    ) + " "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.showBatchEditJobNo
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: 10 } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.BatchEditJobNo")) +
                                      " "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                disabled: !_vm.$checkPermission([
                                  "button_Charge_BatchUnlockReceivable"
                                ]),
                                command: 12
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SeaExport.BatchUnlockReceivableExpenses"
                                  )
                                ) + " "
                              )
                            ]
                          ),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                disabled: !_vm.$checkPermission([
                                  "button_Charge_BatchUnlockPayable"
                                ]),
                                command: 13
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SeaExport.BatchUnlockPayableFees")
                                ) + " "
                              )
                            ]
                          ),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                disabled: !_vm.$checkPermission([
                                  "button_Charge_BatchLockReceivable"
                                ]),
                                command: 14
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SeaExport.BatchLockingReceivableExpenses"
                                  )
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                disabled: !_vm.$checkPermission([
                                  "button_Charge_BatchLockPayable"
                                ]),
                                command: 15
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SeaExport.BatchLockingPayableFees")
                                )
                              )
                            ]
                          ),
                          _vm.$checkPermission([
                            "button_FBABookingNew_fbaBatchUpdateDestinationMsg"
                          ]) && _vm.isFba
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: 16 } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "SeaExport.BatchModifyDestinationPortInformation"
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                disabled: !_vm.$checkPermission([
                                  "button_jobSopTab_BatchReplaceTemplate"
                                ]),
                                command: 18
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SeaExport.ReplaceSOPTemplatesInBatches"
                                  )
                                )
                              )
                            ]
                          ),
                          _vm.useOrderCenterMode && !_vm.isRegionalCommission
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: 19 } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "queryJob.BatchInitiateCollaboration"
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.openMutualTrustConfig &&
                          _vm.$checkPermission([
                            "button_SEBooking_batchPushCharges"
                          ]) &&
                          !_vm.isFba
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: 20 } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.BatchPushCharges"))
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.$checkPermission([
                            "button_JobBooking_BatchFillGpExplain"
                          ])
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: 21 } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.BatchFillGpExplain")
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                disabled: !_vm.$checkPermission([
                                  "button_JobBooking_BatchLockJob"
                                ]),
                                command: 22
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_BatchServiceLocking")
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                disabled: !_vm.$checkPermission([
                                  "button_JobBooking_BatchUnlockJob"
                                ]),
                                command: 23
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "CargoMsg.Cargo_UnlockServicesInBatches"
                                  )
                                )
                              )
                            ]
                          ),
                          _vm.$checkPermission(["button_SEBooking_sendJdy"]) &&
                          _vm.sendToPlatform
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: 24 } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.batchSendJdy"))
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.$checkPermission([
                            "button_SEBooking_unlockJdy"
                          ]) && _vm.sendToPlatform
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: 25 } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "SeaExport.batchUnlockGoodsDetails"
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.$checkPermission([
                            "button_SEBooking_BatchExportToImport"
                          ])
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: "BatchExportToImport" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("queryJob.BatchExportToImport")
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.$checkPermission([
                            "button_JobBooking_ReturnReview"
                          ])
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: 28 } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_BatchReturnPreApproval"
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.editMblNoMode === 3 &&
                          _vm.$checkPermission([
                            "button_SEBooking_BatchAssignMbl"
                          ])
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: "BatchAssignMbl" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "SeaExport.BatchAssignMasterOrderNumbers"
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._l(_vm.instructioinBtns, function(item, index) {
                            return [
                              _c(
                                "el-dropdown-item",
                                {
                                  key: "instruction" + index,
                                  attrs: {
                                    disabled: !item.allowOperate,
                                    command:
                                      "instruction," +
                                      item.tenantInstructionUuid
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$selectByLang(
                                          item.chineseName,
                                          item.englishName,
                                          item.japaneseName
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          })
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-dropdown",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_print_batchPrint"
                          ]),
                          expression:
                            "$checkPermission(['button_print_batchPrint'])"
                        }
                      ],
                      staticStyle: { "margin-right": "5px" },
                      attrs: {
                        no: "BatchPrint",
                        disabled:
                          !_vm.btnInfo.batchSelectFlag ||
                          !_vm.validMultipleSelect,
                        "split-button": "",
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          _vm.onBatchPrint(_vm.$t("SeaExport.BatchPrint"))
                        },
                        command: _vm.onBatchPrint
                      }
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("SeaExport.BatchPrint")) + " "
                      ),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                command: _vm.$t(
                                  "queryJob.PrintByBusinessNumber"
                                )
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("queryJob.PrintByBusinessNumber"))
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "Statistics",
                        type: "primary",
                        disabled: !_vm.validMultipleSelect
                      },
                      on: {
                        click: function($event) {
                          return _vm.toStatistics()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Statistics")))]
                  ),
                  _c(
                    "el-dropdown",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "tab_Charge_chargeView"
                          ]),
                          expression:
                            "$checkPermission(['tab_Charge_chargeView'])"
                        }
                      ],
                      staticStyle: { margin: "0 5px" },
                      attrs: {
                        no: "chargeHandle",
                        "split-button": "",
                        type: "primary",
                        disabled: !_vm.validMultipleSelect
                      },
                      on: {
                        click: _vm.chargeHandle,
                        command: function(p) {
                          _vm.chargeCommand = p
                          _vm.chargeHandle()
                        }
                      }
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.chargeCommand) + " "),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: { command: _vm.$t("SeaExport.AddCharges") }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.AddCharges")) + " "
                              )
                            ]
                          ),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                command: _vm.$t("SeaExport.EditCharges")
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.EditCharges")) + " "
                              )
                            ]
                          ),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                command: _vm.$t("SeaExport.DeleteCharges")
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.DeleteCharges")) + " "
                              )
                            ]
                          ),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                command: _vm.$t("SeaExport.ChargeImport")
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.ChargeImport")) + " "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("cargo-simple-upload", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isFba,
                        expression: "!isFba"
                      }
                    ],
                    attrs: {
                      disabled: !_vm.validMultipleSelect,
                      action: _vm.URL.seaExport.importContainerExcel,
                      title: _vm.$t("SeaExport.ImportTallyInformation"),
                      accept: ".xls,.xlsx",
                      "file-type": [
                        "application/vnd.ms-excel",
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                      ],
                      "check-callback": function() {
                        return _vm.checkHierarchyMulitple()
                      }
                    }
                  }),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            !_vm.isFba &&
                            _vm.contractBinding &&
                            _vm.$checkPermission([
                              "button_Charge_generateByContract"
                            ]),
                          expression:
                            "!isFba && contractBinding && $checkPermission(['button_Charge_generateByContract'])"
                        }
                      ],
                      staticStyle: { "margin-left": "5px" },
                      attrs: {
                        no: "generateByContract",
                        type: "primary",
                        disabled: !_vm.validMultipleSelect
                      },
                      on: {
                        click: function($event) {
                          return _vm.generateChargeByContractNo()
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("ChangeCharge.generateByContract")) + " "
                      )
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            !_vm.isFba &&
                            _vm.$checkPermission([
                              "button_SEBooking_combinationJob"
                            ]),
                          expression:
                            "!isFba && $checkPermission(['button_SEBooking_combinationJob'])"
                        }
                      ],
                      attrs: {
                        no: "Combination",
                        type: "primary",
                        disabled: !_vm.validMultipleSelect
                      },
                      on: { click: _vm.combinationJob }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Combination")) + " ")]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            !_vm.isFba &&
                            _vm.$checkPermission(["button_SEBooking_splitJob"]),
                          expression:
                            "!isFba && $checkPermission(['button_SEBooking_splitJob'])"
                        }
                      ],
                      attrs: {
                        no: "Split",
                        type: "primary",
                        disabled: !_vm.validMultipleSelect
                      },
                      on: { click: _vm.splitJob }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Split")) + " ")]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isFba,
                          expression: "!isFba"
                        }
                      ],
                      attrs: { no: "FinalStepSync", type: "primary" },
                      on: { click: _vm.finalStepSync }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.FinalStepSyncBtn")) + " ")]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission(["button_ledger"]),
                          expression: "$checkPermission(['button_ledger'])"
                        }
                      ],
                      attrs: {
                        no: "unlockApply",
                        type: "primary",
                        disabled: !_vm.validMultipleSelect
                      },
                      on: { click: _vm.toUnlockApply }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.UnlockApplyBtn")) + " ")]
                  ),
                  !_vm.isFba && _vm.seExcelImportPT
                    ? _c("cargo-simple-upload", {
                        staticStyle: { margin: "0 5px" },
                        attrs: {
                          disabled: !_vm.validMultipleSelect,
                          action: _vm.URL.seaExport.PTExcelDataForJc,
                          params: {
                            deptId: Number(_vm.curDepId),
                            fileIdx: "",
                            officeId: _vm.curOfficeId
                          },
                          title: _vm.$t("SeaExport.PTImport"),
                          accept: ".xls,.xlsx",
                          "file-type": [
                            "application/vnd.ms-excel",
                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                          ],
                          "check-callback": function() {
                            return _vm.checkHierarchyMulitple()
                          }
                        },
                        on: { success: _vm.ptSuccess }
                      })
                    : _vm._e(),
                  _c(
                    "el-dropdown",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            !_vm.isFba &&
                            _vm.$checkPermission(["button_Charge_easSync"]) &&
                            _vm.toExoSystemEAS,
                          expression:
                            "!isFba && $checkPermission(['button_Charge_easSync']) && toExoSystemEAS"
                        }
                      ],
                      staticStyle: { margin: "0 5px", "font-size": "12px" },
                      attrs: { disabled: !_vm.validMultipleSelect },
                      on: { command: _vm.batchEasSyncHandle }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            disabled: !_vm.btnInfo.batchSelectFlag
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("SeaExport.SyncChargeToEas")) +
                              " "
                          ),
                          _c("i", {
                            staticClass: "el-icon-arrow-down el-icon--right"
                          })
                        ]
                      ),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [
                          _c("el-dropdown-item", { attrs: { command: 1 } }, [
                            _vm._v(_vm._s(_vm.$t("SeaExport.receivable")))
                          ]),
                          _c("el-dropdown-item", { attrs: { command: 2 } }, [
                            _vm._v(_vm._s(_vm.$t("SeaExport.payable")))
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-dropdown",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.toExoSystemYGSH &&
                            _vm.$checkPermission(["button_Charge_ltsSync"]),
                          expression:
                            "toExoSystemYGSH && $checkPermission(['button_Charge_ltsSync'])"
                        }
                      ],
                      staticStyle: { margin: "0 5px", "font-size": "12px" },
                      attrs: { disabled: !_vm.validMultipleSelect },
                      on: { command: _vm.batchLtsSyncHandle }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            disabled: !_vm.btnInfo.batchSelectFlag
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "CargoMsg.Cargo_SynchronousCloudPlatform"
                                )
                              ) +
                              " "
                          ),
                          _c("i", {
                            staticClass: "el-icon-arrow-down el-icon--right"
                          })
                        ]
                      ),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [
                          _c("el-dropdown-item", { attrs: { command: 1 } }, [
                            _vm._v(_vm._s(_vm.$t("SeaExport.receivable")))
                          ]),
                          _c("el-dropdown-item", { attrs: { command: 2 } }, [
                            _vm._v(_vm._s(_vm.$t("SeaExport.payable")))
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "section grid-wrapper",
              staticStyle: { position: "relative" }
            },
            [
              !_vm.isFba
                ? _c("cargo-ag-grid-wrapper", {
                    attrs: {
                      "config-module": "130001",
                      "per-config-name": _vm.perConfigName,
                      "refresh-id": _vm.gridRefreshId,
                      "grid-options": _vm.gridOptions,
                      "side-bar": {
                        toolPanels: ["columns", "filter"],
                        visible: false
                      },
                      "column-defs": _vm.finalColumnDefs,
                      "row-data": _vm.rowData,
                      "grid-params": _vm.gridParams,
                      "check-main-record": false,
                      "deselect-main-record": false,
                      "wrap-text": false,
                      "show-selected-color": false,
                      "show-row-groups": _vm.dataListDragGroup,
                      "darg-group-show-column-def": _vm.dargGroupShowColumnDef
                    },
                    on: {
                      "update:gridParams": function($event) {
                        _vm.gridParams = $event
                      },
                      "update:grid-params": function($event) {
                        _vm.gridParams = $event
                      },
                      gridReady: _vm.onGridReady,
                      columnRowGroupChanged: function() {
                        this$1.$refs[
                          _vm.searchItemConfigModule
                        ].clickCollapseList()
                      }
                    }
                  })
                : _vm._e(),
              _vm.isFba
                ? _c("cargo-ag-grid-wrapper", {
                    attrs: {
                      "config-module": "10010",
                      "per-config-name": _vm.perConfigName,
                      "refresh-id": _vm.gridRefreshId,
                      "grid-options": _vm.gridOptions,
                      "side-bar": {
                        toolPanels: ["columns", "filter"],
                        visible: false
                      },
                      "column-defs": _vm.fbaColumnDefs,
                      "row-data": _vm.rowData,
                      "grid-params": _vm.gridParams,
                      "check-main-record": false,
                      "deselect-main-record": false,
                      "wrap-text": false,
                      "show-selected-color": false,
                      "show-row-groups": _vm.dataListDragGroup,
                      "darg-group-show-column-def": _vm.dargGroupShowColumnDef
                    },
                    on: {
                      "update:gridParams": function($event) {
                        _vm.gridParams = $event
                      },
                      "update:grid-params": function($event) {
                        _vm.gridParams = $event
                      },
                      gridReady: _vm.onGridReady
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("cargo-pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.appendQuery,
                    expression: "!appendQuery"
                  }
                ],
                attrs: {
                  "config-module": _vm.isFba ? "10010" : "130001",
                  total: _vm.total,
                  "page-count": _vm.pageCount,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize,
                  "selected-row-count": _vm.isFba ? 0 : _vm.selectedRowCount
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: function() {
                    if (_vm.total > 0) {
                      _vm.toQuery()
                    }
                  }
                }
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.appendQuery,
                      expression: "appendQuery"
                    }
                  ],
                  staticClass: "pagination-container"
                },
                [
                  _c("el-pagination", {
                    staticStyle: { "text-align": "left" },
                    attrs: { total: _vm.total, layout: "total" }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.stateDialog.visible
        ? _c("state-dialog", {
            attrs: {
              visible: _vm.stateDialog.visible,
              rows: _vm.stateDialog.rows,
              "tracking-list": _vm.stateDialog.trackingList
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.stateDialog, "visible", $event)
              },
              callback: function($event) {
                return _vm.toQuery()
              }
            }
          })
        : _vm._e(),
      _vm.shutOutDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.shutOutDialog.visible,
                title: _vm.$t("Message.Warning"),
                width: "400px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.shutOutDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "column",
                    "padding-left": "30px"
                  }
                },
                [
                  _c("span", { staticStyle: { "line-height": "40px" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("Message.PleaseConfirmTheShutOut")) + "？"
                    )
                  ]),
                  _c("span", { staticStyle: { "line-height": "18px" } }, [
                    _vm._v(_vm._s(_vm.shutOutDialog.shutOutTip1))
                  ]),
                  _c("span", { staticStyle: { "line-height": "18px" } }, [
                    _vm._v(_vm._s(_vm.shutOutDialog.shutOutTip2))
                  ])
                ]
              ),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.hasChargeShutoutHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Message.HasChargeToShutOut")))]
                  ),
                  _c(
                    "el-button",
                    {
                      style: { display: _vm.shutOutDialog.shutOutButtonShow2 },
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.noHasChargeShutoutHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Message.NoChargeToShutOut")) + " ")]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.shutOutDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm.transshipDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.transshipDialog.visible,
                title: _vm.$t("SeaExport.BatchVessel"),
                width: _vm.$selectByLang(
                  "850px",
                  "850px",
                  "850px",
                  "900px",
                  "900px",
                  "900px"
                ),
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.transshipDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                [
                  _c(
                    "el-form",
                    {
                      staticStyle: { "padding-right": "20px" },
                      attrs: {
                        "label-width": "120px",
                        "label-position": "left"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.VesselAndVoyage") }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  no: "vesselAndVoyage",
                                  disabled: _vm.clearCheckBox.vesselAndVoyage
                                },
                                on: {
                                  input: function(value) {
                                    return _vm.onVesselAndVoyageChange(value)
                                  }
                                },
                                model: {
                                  value: _vm.transshipDialog.vesselAndVoyage,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.transshipDialog,
                                      "vesselAndVoyage",
                                      $$v
                                    )
                                  },
                                  expression: "transshipDialog.vesselAndVoyage"
                                }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    change: function($event) {
                                      return _vm.clearCheckBoxChange(
                                        "vesselAndVoyage"
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.clearCheckBox.vesselAndVoyage,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.clearCheckBox,
                                        "vesselAndVoyage",
                                        $$v
                                      )
                                    },
                                    expression: "clearCheckBox.vesselAndVoyage"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Vessel") } },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("cargo-advance-select", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.transshipDialog.isDBFlag,
                                    expression: "!transshipDialog.isDBFlag"
                                  }
                                ],
                                staticStyle: { width: "195px" },
                                attrs: {
                                  disabled: _vm.clearCheckBox.vessel,
                                  filterable: "",
                                  "options-width": "195px;",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Vessel,
                                  "default-value":
                                    _vm.transshipDialog.txtVessel,
                                  "callback-params": { key: "txtVessel" }
                                },
                                on: {
                                  parentCallBack: _vm.onVesselSelectionChange
                                }
                              }),
                              _c("cargo-advance-select", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.transshipDialog.isDBFlag,
                                    expression: "transshipDialog.isDBFlag"
                                  }
                                ],
                                staticClass: "date-blue",
                                attrs: {
                                  disabled: _vm.clearCheckBox.vessel,
                                  "select-type":
                                    _vm.selectTypeNames.static_data_Vessel,
                                  "static-options":
                                    _vm.transshipDialog.vesselList,
                                  cache: false,
                                  filterable: "",
                                  "allow-create": true,
                                  "default-value":
                                    _vm.transshipDialog.txtVessel_1
                                },
                                on: {
                                  parentCallBack: _vm.onVesselSelectionChange
                                }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    change: function($event) {
                                      return _vm.clearCheckBoxChange("vessel")
                                    }
                                  },
                                  model: {
                                    value: _vm.clearCheckBox.vessel,
                                    callback: function($$v) {
                                      _vm.$set(_vm.clearCheckBox, "vessel", $$v)
                                    },
                                    expression: "clearCheckBox.vessel"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.CarrierVoyage") } },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: _vm.clearCheckBox.carrierVoyage
                                },
                                model: {
                                  value: _vm.transshipDialog.carrierVoyage,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.transshipDialog,
                                      "carrierVoyage",
                                      $$v
                                    )
                                  },
                                  expression: "transshipDialog.carrierVoyage"
                                }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    change: function($event) {
                                      return _vm.clearCheckBoxChange(
                                        "carrierVoyage"
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.clearCheckBox.carrierVoyage,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.clearCheckBox,
                                        "carrierVoyage",
                                        $$v
                                      )
                                    },
                                    expression: "clearCheckBox.carrierVoyage"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.BookingShipCallSign")
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled:
                                    _vm.clearCheckBox.bookingShipCallSign
                                },
                                model: {
                                  value:
                                    _vm.transshipDialog.bookingShipCallSign,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.transshipDialog,
                                      "bookingShipCallSign",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "transshipDialog.bookingShipCallSign"
                                }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    change: function($event) {
                                      return _vm.clearCheckBoxChange(
                                        "bookingShipCallSign"
                                      )
                                    }
                                  },
                                  model: {
                                    value:
                                      _vm.clearCheckBox.bookingShipCallSign,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.clearCheckBox,
                                        "bookingShipCallSign",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "clearCheckBox.bookingShipCallSign"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_PortOfLoading")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "195px" },
                            attrs: {
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              "default-value":
                                _vm.transshipDialog.loadingPortCode
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.transshipDialog.loadingPortCode = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.ShippingCompany") }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "195px" },
                                attrs: {
                                  disabled: _vm.clearCheckBox.carrierId,
                                  filterable: "",
                                  "options-width": "200px;",
                                  "method-params": {
                                    seaCmp: true,
                                    active: true
                                  },
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "default-value":
                                    _vm.transshipDialog.txtCarrierId || ""
                                },
                                on: {
                                  parentCallBack: _vm.onCarrierIdSelectionChange
                                }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    change: function($event) {
                                      return _vm.clearCheckBoxChange(
                                        "carrierId"
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.clearCheckBox.carrierId,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.clearCheckBox,
                                        "carrierId",
                                        $$v
                                      )
                                    },
                                    expression: "clearCheckBox.carrierId"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.DateOfDeparture2") }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "195px" },
                            attrs: {
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.transshipDialog.dfETD,
                              callback: function($$v) {
                                _vm.$set(_vm.transshipDialog, "dfETD", $$v)
                              },
                              expression: "transshipDialog.dfETD"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.DateOfArrival2") }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "195px" },
                                attrs: {
                                  disabled: _vm.clearCheckBox.eta,
                                  type: "date",
                                  "value-format": "yyyy-MM-dd"
                                },
                                model: {
                                  value: _vm.transshipDialog.dfETA,
                                  callback: function($$v) {
                                    _vm.$set(_vm.transshipDialog, "dfETA", $$v)
                                  },
                                  expression: "transshipDialog.dfETA"
                                }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    change: function($event) {
                                      return _vm.clearCheckBoxChange("eta")
                                    }
                                  },
                                  model: {
                                    value: _vm.clearCheckBox.eta,
                                    callback: function($$v) {
                                      _vm.$set(_vm.clearCheckBox, "eta", $$v)
                                    },
                                    expression: "clearCheckBox.eta"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.ActualDateOfDeparture2")
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "195px" },
                                attrs: {
                                  disabled: _vm.clearCheckBox.atd,
                                  type: "date",
                                  "value-format": "yyyy-MM-dd"
                                },
                                model: {
                                  value: _vm.transshipDialog.dfATD,
                                  callback: function($$v) {
                                    _vm.$set(_vm.transshipDialog, "dfATD", $$v)
                                  },
                                  expression: "transshipDialog.dfATD"
                                }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    change: function($event) {
                                      return _vm.clearCheckBoxChange("atd")
                                    }
                                  },
                                  model: {
                                    value: _vm.clearCheckBox.atd,
                                    callback: function($$v) {
                                      _vm.$set(_vm.clearCheckBox, "atd", $$v)
                                    },
                                    expression: "clearCheckBox.atd"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.ActualDateOfArrival2")
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "195px" },
                                attrs: {
                                  disabled: _vm.clearCheckBox.ata,
                                  type: "date",
                                  "value-format": "yyyy-MM-dd"
                                },
                                model: {
                                  value: _vm.transshipDialog.dfATA,
                                  callback: function($$v) {
                                    _vm.$set(_vm.transshipDialog, "dfATA", $$v)
                                  },
                                  expression: "transshipDialog.dfATA"
                                }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    change: function($event) {
                                      return _vm.clearCheckBoxChange("ata")
                                    }
                                  },
                                  model: {
                                    value: _vm.clearCheckBox.ata,
                                    callback: function($$v) {
                                      _vm.$set(_vm.clearCheckBox, "ata", $$v)
                                    },
                                    expression: "clearCheckBox.ata"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_AirlineCode") }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "195px" },
                            attrs: { disabled: true },
                            model: {
                              value: _vm.transshipDialog.routeCode,
                              callback: function($$v) {
                                _vm.$set(_vm.transshipDialog, "routeCode", $$v)
                              },
                              expression: "transshipDialog.routeCode"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.DeclareCutOffDate")
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled: _vm.clearCheckBox.declareCutOff,
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm"
                                },
                                model: {
                                  value: _vm.transshipDialog.declareCutOff,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.transshipDialog,
                                      "declareCutOff",
                                      $$v
                                    )
                                  },
                                  expression: "transshipDialog.declareCutOff"
                                }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    change: function($event) {
                                      return _vm.clearCheckBoxChange(
                                        "declareCutOff"
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.clearCheckBox.declareCutOff,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.clearCheckBox,
                                        "declareCutOff",
                                        $$v
                                      )
                                    },
                                    expression: "clearCheckBox.declareCutOff"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": "120px",
                        "label-position": "left"
                      }
                    },
                    [
                      _c("el-form-item", { staticStyle: { height: "28px" } }),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Voyage") } },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c(
                                "el-select",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.transshipDialog.isVoyages,
                                      expression: "!transshipDialog.isVoyages"
                                    }
                                  ],
                                  staticStyle: { width: "195px" },
                                  attrs: { disabled: _vm.clearCheckBox.voyage },
                                  on: { change: _vm.onVoyageFlightChange },
                                  model: {
                                    value: _vm.transshipDialog.txtVoyage,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.transshipDialog,
                                        "txtVoyage",
                                        $$v
                                      )
                                    },
                                    expression: "transshipDialog.txtVoyage"
                                  }
                                },
                                _vm._l(_vm.transshipDialog.voyages, function(
                                  item
                                ) {
                                  return _c("el-option", {
                                    key: item.voyageId,
                                    attrs: {
                                      label: item.voyageNo,
                                      value: item.voyageNo
                                    }
                                  })
                                }),
                                1
                              ),
                              _c("cargo-advance-select", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.transshipDialog.isVoyages,
                                    expression: "transshipDialog.isVoyages"
                                  }
                                ],
                                attrs: {
                                  disabled: _vm.clearCheckBox.voyage,
                                  "static-options":
                                    _vm.transshipDialog.voyages || [],
                                  cache: false,
                                  "default-value":
                                    _vm.transshipDialog.txtVoyage_1,
                                  filterable: "",
                                  clearable: "",
                                  "allow-create": true,
                                  "tag-name": "voyageNo",
                                  "tag-value": "voyageNo",
                                  "filter-tag-names": ["voyageNo"]
                                },
                                on: { parentCallBack: _vm.onVoyageFlightChange }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    change: function($event) {
                                      return _vm.clearCheckBoxChange("voyage")
                                    }
                                  },
                                  model: {
                                    value: _vm.clearCheckBox.voyage,
                                    callback: function($$v) {
                                      _vm.$set(_vm.clearCheckBox, "voyage", $$v)
                                    },
                                    expression: "clearCheckBox.voyage"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.HarborDistrict") }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: _vm.clearCheckBox.portDistrict
                                },
                                model: {
                                  value: _vm.transshipDialog.portDistrict,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.transshipDialog,
                                      "portDistrict",
                                      $$v
                                    )
                                  },
                                  expression: "transshipDialog.portDistrict"
                                }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    change: function($event) {
                                      return _vm.clearCheckBoxChange(
                                        "portDistrict"
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.clearCheckBox.portDistrict,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.clearCheckBox,
                                        "portDistrict",
                                        $$v
                                      )
                                    },
                                    expression: "clearCheckBox.portDistrict"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c("el-form-item", { attrs: { label: "IMO" } }, [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-input", {
                              attrs: { disabled: _vm.clearCheckBox.imo },
                              model: {
                                value: _vm.transshipDialog.imo,
                                callback: function($$v) {
                                  _vm.$set(_vm.transshipDialog, "imo", $$v)
                                },
                                expression: "transshipDialog.imo"
                              }
                            }),
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { "margin-left": "10px" },
                                on: {
                                  change: function($event) {
                                    return _vm.clearCheckBoxChange("imo")
                                  }
                                },
                                model: {
                                  value: _vm.clearCheckBox.imo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.clearCheckBox, "imo", $$v)
                                  },
                                  expression: "clearCheckBox.imo"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_PortOfDischarge")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "195px" },
                            attrs: {
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              "default-value":
                                _vm.transshipDialog.dischargingPortCode
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.transshipDialog.dischargingPortCode =
                                  p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.BookingAgent") } },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "195px" },
                                attrs: {
                                  disabled: _vm.clearCheckBox.bookingAgent,
                                  filterable: "",
                                  "options-width": "200px;",
                                  "method-params": {
                                    bookingAgent: true,
                                    active: true
                                  },
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "default-value":
                                    _vm.transshipDialog.txtBookingAgent || ""
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    return (_vm.transshipDialog.txtBookingAgent =
                                      p.cmpIdx)
                                  }
                                }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    change: function($event) {
                                      return _vm.clearCheckBoxChange(
                                        "bookingAgent"
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.clearCheckBox.bookingAgent,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.clearCheckBox,
                                        "bookingAgent",
                                        $$v
                                      )
                                    },
                                    expression: "clearCheckBox.bookingAgent"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.CarrierAgent") } },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("cargo-company-select", {
                                staticStyle: { width: "195px" },
                                attrs: {
                                  disabled: _vm.clearCheckBox.carrierAgent,
                                  "method-params": {
                                    seaCmpAgent: true,
                                    companyLob: "seaExport",
                                    active: true
                                  },
                                  "default-value":
                                    _vm.transshipDialog.txtCarrierAgent || ""
                                },
                                on: {
                                  change: function(p) {
                                    _vm.transshipDialog.txtCarrierAgent =
                                      p.value
                                  }
                                }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    change: function($event) {
                                      return _vm.clearCheckBoxChange(
                                        "carrierAgent"
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.clearCheckBox.carrierAgent,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.clearCheckBox,
                                        "carrierAgent",
                                        $$v
                                      )
                                    },
                                    expression: "clearCheckBox.carrierAgent"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t("SeaExport.PortAreaCYOpeningTime")
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled: _vm.clearCheckBox.terminalOpendate,
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm"
                                },
                                model: {
                                  value: _vm.transshipDialog.terminalOpendate,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.transshipDialog,
                                      "terminalOpendate",
                                      $$v
                                    )
                                  },
                                  expression: "transshipDialog.terminalOpendate"
                                }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    change: function($event) {
                                      return _vm.clearCheckBoxChange(
                                        "terminalOpendate"
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.clearCheckBox.terminalOpendate,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.clearCheckBox,
                                        "terminalOpendate",
                                        $$v
                                      )
                                    },
                                    expression: "clearCheckBox.terminalOpendate"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t("SeaExport.PortAreaCYCutOffTime")
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled: _vm.clearCheckBox.terminalCutoff,
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm"
                                },
                                model: {
                                  value: _vm.transshipDialog.terminalCutoff,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.transshipDialog,
                                      "terminalCutoff",
                                      $$v
                                    )
                                  },
                                  expression: "transshipDialog.terminalCutoff"
                                }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    change: function($event) {
                                      return _vm.clearCheckBoxChange(
                                        "terminalCutoff"
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.clearCheckBox.terminalCutoff,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.clearCheckBox,
                                        "terminalCutoff",
                                        $$v
                                      )
                                    },
                                    expression: "clearCheckBox.terminalCutoff"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.DocCutOffDate") } },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled: _vm.clearCheckBox.fileCutoff,
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm"
                                },
                                model: {
                                  value: _vm.transshipDialog.fileCutoff,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.transshipDialog,
                                      "fileCutoff",
                                      $$v
                                    )
                                  },
                                  expression: "transshipDialog.fileCutoff"
                                }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    change: function($event) {
                                      return _vm.clearCheckBoxChange(
                                        "fileCutoff"
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.clearCheckBox.fileCutoff,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.clearCheckBox,
                                        "fileCutoff",
                                        $$v
                                      )
                                    },
                                    expression: "clearCheckBox.fileCutoff"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.CYCutOffDate2") } },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled: _vm.clearCheckBox.customCutoff,
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm"
                                },
                                model: {
                                  value: _vm.transshipDialog.customCutoff,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.transshipDialog,
                                      "customCutoff",
                                      $$v
                                    )
                                  },
                                  expression: "transshipDialog.customCutoff"
                                }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    change: function($event) {
                                      return _vm.clearCheckBoxChange(
                                        "customCutoff"
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.clearCheckBox.customCutoff,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.clearCheckBox,
                                        "customCutoff",
                                        $$v
                                      )
                                    },
                                    expression: "clearCheckBox.customCutoff"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_CarrierCode") }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: _vm.clearCheckBox.carrierCode
                                },
                                model: {
                                  value: _vm.transshipDialog.carrierCode,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.transshipDialog,
                                      "carrierCode",
                                      $$v
                                    )
                                  },
                                  expression: "transshipDialog.carrierCode"
                                }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    change: function($event) {
                                      return _vm.clearCheckBoxChange(
                                        "carrierCode"
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.clearCheckBox.carrierCode,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.clearCheckBox,
                                        "carrierCode",
                                        $$v
                                      )
                                    },
                                    expression: "clearCheckBox.carrierCode"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.CustomerClosingTime")
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled:
                                    _vm.clearCheckBox.customerFileCutoff,
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm"
                                },
                                model: {
                                  value: _vm.transshipDialog.customerFileCutoff,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.transshipDialog,
                                      "customerFileCutoff",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "transshipDialog.customerFileCutoff"
                                }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    change: function($event) {
                                      return _vm.clearCheckBoxChange(
                                        "customerFileCutoff"
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.clearCheckBox.customerFileCutoff,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.clearCheckBox,
                                        "customerFileCutoff",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "clearCheckBox.customerFileCutoff"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.transShipClickHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.transshipDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm.scNoDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.scNoDialog.visible,
                title: _vm.$t("SeaExport.BatchUpdateScNo"),
                width: "360px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.scNoDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "85px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.ShippingCompanyContractNo")
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "195px" },
                        model: {
                          value: _vm.scNoDialog.scNo,
                          callback: function($$v) {
                            _vm.$set(_vm.scNoDialog, "scNo", $$v)
                          },
                          expression: "scNoDialog.scNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.InnerContractNo") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "195px" },
                        model: {
                          value: _vm.scNoDialog.contractNo,
                          callback: function($$v) {
                            _vm.$set(_vm.scNoDialog, "contractNo", $$v)
                          },
                          expression: "scNoDialog.contractNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.quotationNum") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "195px" },
                        model: {
                          value: _vm.scNoDialog.quotationNum,
                          callback: function($$v) {
                            _vm.$set(_vm.scNoDialog, "quotationNum", $$v)
                          },
                          expression: "scNoDialog.quotationNum"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.toBatchUpdateScNoConfirm }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.scNoDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.customJobTypeDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.customJobTypeDialog.visible,
                title: _vm.$t("SeaExport.BatchUpdateCustomJobType"),
                width: "400px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.customJobTypeDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "120px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.CustomJobType") + ":" }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          "select-type":
                            _vm.selectTypeNames.basic_data_CutomJobType,
                          filterable: "",
                          "method-params": { type: "SE", active: true },
                          "default-value": _vm.customJobTypeDialog.customJobType
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.customJobTypeDialog.customJobType = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.customJobTypeClickHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.customJobTypeDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.fullSpellTypeDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.fullSpellTypeDialog.visible,
                title: _vm.$t("SeaExport.BatchUpdateType"),
                width: _vm.$selectByLang("400px", "400px", "420px"),
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.fullSpellTypeDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    "label-width": _vm.$selectByLang("120px", "120px", "140px"),
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: {
                        label: _vm.$t("SeaExport.BatchUpdateType") + ":"
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "190px" },
                          model: {
                            value: _vm.fullSpellTypeDialog.containerLoadType,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.fullSpellTypeDialog,
                                "containerLoadType",
                                $$v
                              )
                            },
                            expression: "fullSpellTypeDialog.containerLoadType"
                          }
                        },
                        _vm._l(
                          _vm.fullSpellTypeDialog.containerLoadTypes,
                          function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: _vm.$getLangColumn(item),
                                value: item.code
                              }
                            })
                          }
                        ),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.fullSpellTypeClickHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.fullSpellTypeDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.ctx,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          context: _vm.context,
          "job-uuid-list": _vm.jobUuidList,
          "pre-print-callback": _vm.prePrintCallback,
          "printed-callback": _vm.printedCallback,
          "v2-check-callback": _vm.v2CheckCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _vm.statisticsDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.statisticsDialog.visible,
                title: _vm.$t("SeaExport.Statistics"),
                width: _vm.$selectByLang("360px", "445px"),
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.statisticsDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    "label-width": _vm.$selectByLang("85px", "170px"),
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.Slaves") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtSlaves,
                          callback: function($$v) {
                            _vm.$set(_vm.statisticsDialog, "txtSlaves", $$v)
                          },
                          expression: "statisticsDialog.txtSlaves"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.Master") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtMaster,
                          callback: function($$v) {
                            _vm.$set(_vm.statisticsDialog, "txtMaster", $$v)
                          },
                          expression: "statisticsDialog.txtMaster"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.TotalTickets") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtCount,
                          callback: function($$v) {
                            _vm.$set(_vm.statisticsDialog, "txtCount", $$v)
                          },
                          expression: "statisticsDialog.txtCount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.CustomerCount") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtCustomerCount,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.statisticsDialog,
                              "txtCustomerCount",
                              $$v
                            )
                          },
                          expression: "statisticsDialog.txtCustomerCount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "custom", attrs: { label: "20＇" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txt20,
                          callback: function($$v) {
                            _vm.$set(_vm.statisticsDialog, "txt20", $$v)
                          },
                          expression: "statisticsDialog.txt20"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "custom", attrs: { label: "40＇" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txt40,
                          callback: function($$v) {
                            _vm.$set(_vm.statisticsDialog, "txt40", $$v)
                          },
                          expression: "statisticsDialog.txt40"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "custom", attrs: { label: "40HQ＇" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txt40hq,
                          callback: function($$v) {
                            _vm.$set(_vm.statisticsDialog, "txt40hq", $$v)
                          },
                          expression: "statisticsDialog.txt40hq"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "custom", attrs: { label: "45＇" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txt45,
                          callback: function($$v) {
                            _vm.$set(_vm.statisticsDialog, "txt45", $$v)
                          },
                          expression: "statisticsDialog.txt45"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "custom", attrs: { label: "TEU" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtTeu,
                          callback: function($$v) {
                            _vm.$set(_vm.statisticsDialog, "txtTeu", $$v)
                          },
                          expression: "statisticsDialog.txtTeu"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.Weight2") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtWeight,
                          callback: function($$v) {
                            _vm.$set(_vm.statisticsDialog, "txtWeight", $$v)
                          },
                          expression: "statisticsDialog.txtWeight"
                        }
                      }),
                      _c("span", [_vm._v("KGS")])
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.Cubage") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtCubage,
                          callback: function($$v) {
                            _vm.$set(_vm.statisticsDialog, "txtCubage", $$v)
                          },
                          expression: "statisticsDialog.txtCubage"
                        }
                      }),
                      _c("span", [_vm._v("CBM")])
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.ChargedWeight") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtChargeWeight,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.statisticsDialog,
                              "txtChargeWeight",
                              $$v
                            )
                          },
                          expression: "statisticsDialog.txtChargeWeight"
                        }
                      }),
                      _c("span", [_vm._v("M/T")])
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.SpecifyAgentNumber") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtdesignationAgentNum,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.statisticsDialog,
                              "txtdesignationAgentNum",
                              $$v
                            )
                          },
                          expression: "statisticsDialog.txtdesignationAgentNum"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "custom", attrs: { "label-width": "0" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { "margin-right": "10px" },
                          on: {
                            change: function($event) {
                              return _vm.handleStatistics(true)
                            }
                          },
                          model: {
                            value: _vm.statisticsDialog.containShutOutJob,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.statisticsDialog,
                                "containShutOutJob",
                                $$v
                              )
                            },
                            expression: "statisticsDialog.containShutOutJob"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SeaExport.ContainShutOutJob")) + " "
                          )
                        ]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          on: {
                            change: _vm.changeWeightCubageChargeWeightByJoint
                          },
                          model: {
                            value:
                              _vm.statisticsDialog
                                .weightCubageChargeWeightByJoint,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.statisticsDialog,
                                "weightCubageChargeWeightByJoint",
                                $$v
                              )
                            },
                            expression:
                              "statisticsDialog.weightCubageChargeWeightByJoint"
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "SeaExport.weightVolumeBillWeightConsolidated"
                                )
                              ) +
                              " "
                          ),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: _vm.$t(
                                  "SeaExport.weightVolumeBillWeightConsolidatedTip"
                                ),
                                placement: "top"
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-question",
                                staticStyle: {
                                  color: "#1F75D5",
                                  "font-size": "16px"
                                }
                              })
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.statisticsDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Close")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.addChargeDetailDialog.visible
        ? _c("add-charge-detail-dialog", {
            attrs: {
              visible: _vm.addChargeDetailDialog.visible,
              "selected-jobs": _vm.addChargeDetailDialog.selectedJobs,
              "charge-type": _vm.addChargeDetailDialog.type,
              lob: _vm.isFba ? "FBA_SE" : "SE",
              location: _vm.location,
              "selected-scheme": _vm.addChargeDetailDialog.selectedScheme
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.addChargeDetailDialog, "visible", $event)
              },
              toChangeSchema: _vm.toChangeSchema
            }
          })
        : _vm._e(),
      _vm.editChargeDetailDialog.visible
        ? _c("edit-charge-detail-dialog", {
            attrs: {
              visible: _vm.editChargeDetailDialog.visible,
              "selected-jobs": _vm.editChargeDetailDialog.selectedJobs,
              "charge-type": _vm.editChargeDetailDialog.chargeType,
              lob: _vm.isFba ? "FBA_SE" : "SE"
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.editChargeDetailDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.deleteChargeDetailDialog.visible
        ? _c("delete-charge-detail-dialog", {
            attrs: {
              visible: _vm.deleteChargeDetailDialog.visible,
              "selected-jobs": _vm.deleteChargeDetailDialog.selectedJobs,
              "charge-type": _vm.deleteChargeDetailDialog.chargeType,
              lob: _vm.isFba ? "FBA_SE" : "SE"
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.deleteChargeDetailDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.unlockApplyDialog.visible
        ? _c("unlock-apply-dialog", {
            attrs: {
              visible: _vm.unlockApplyDialog.visible,
              "selected-jobs": _vm.unlockApplyDialog.selectedJobs
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.unlockApplyDialog, "visible", $event)
              },
              success: _vm.toQuery
            }
          })
        : _vm._e(),
      _vm.chargeSchemeBatchDialog.visible
        ? _c("charge-scheme-batch-dialog", {
            attrs: {
              visible: _vm.chargeSchemeBatchDialog.visible,
              "selected-jobs": _vm.chargeSchemeBatchDialog.selectedJobs,
              job: _vm.chargeSchemeBatchDialog.job,
              "need-check-range": _vm.chargeSchemeBatchDialog.needCheckRange,
              lob: _vm.chargeSchemeBatchDialog.lob,
              "is-sea": _vm.chargeSchemeBatchDialog.isSea,
              "original-condition":
                _vm.chargeSchemeBatchDialog.originalCondition,
              "charge-scheme-is-approved":
                _vm.chargeSchemeBatchDialog.chargeSchemeIsApproved,
              location: _vm.location,
              "charge-type": _vm.chargeSchemeBatchDialog.chargeType,
              source: _vm.chargeSchemeBatchDialog.source
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.chargeSchemeBatchDialog, "visible", $event)
              },
              selectedSchemeHandler: _vm.handleSelectedScheme
            }
          })
        : _vm._e(),
      _vm.batchCheckingWindow.visible
        ? _c("batch-checking-window", {
            ref: "batchCheckingWindow",
            attrs: {
              visible: _vm.batchCheckingWindow.visible,
              "allow-partial-check-pass":
                _vm.batchCheckingWindow.allowPartialCheckPass,
              lob: _vm.lob,
              jobs: _vm.batchCheckingWindow.jobs,
              "check-node": _vm.batchCheckingWindow.checkNode,
              "call-back": _vm.batchCheckingWindow.callBack,
              "call-back2": _vm.batchCheckingWindow.callBack2
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.batchCheckingWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "sop-state-wrapper-grid" },
        [
          _c("sop-state-dialog", {
            attrs: {
              visible: _vm.sopStateDialog.visible,
              "is-need-refresh": _vm.sopStateDialog.isNeedRefresh,
              job: _vm.currentRow
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.sopStateDialog, "visible", $event)
              },
              "update:isNeedRefresh": function($event) {
                return _vm.$set(_vm.sopStateDialog, "isNeedRefresh", $event)
              },
              "update:is-need-refresh": function($event) {
                return _vm.$set(_vm.sopStateDialog, "isNeedRefresh", $event)
              },
              handleClose: _vm.sopStateDialogClose
            }
          })
        ],
        1
      ),
      _vm.combinationJobDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.combinationJobDialog.visible,
                title: _vm.$t("SeaExport.CombinationJob"),
                width: "500px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.combinationJobDialog, "visible", $event)
                }
              }
            },
            [
              _c("div", { staticStyle: { "text-align": "center" } }, [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("Message.CombinationJobSelectMasterTip"))
                  )
                ])
              ]),
              _c("cargo-ag-grid", {
                staticStyle: { "margin-top": "10px" },
                attrs: {
                  "grid-options": _vm.combinationJobDialog.gridOptions,
                  "column-defs": _vm.combinationJobDialog.columnDefs,
                  "row-data": _vm.combinationJobDialog.rowData,
                  "grid-params": _vm.combinationJobDialog.gridParams,
                  "check-main-record": false,
                  "deselect-main-record": false,
                  "min-height": "150px"
                },
                on: {
                  "update:gridParams": function($event) {
                    return _vm.$set(
                      _vm.combinationJobDialog,
                      "gridParams",
                      $event
                    )
                  },
                  "update:grid-params": function($event) {
                    return _vm.$set(
                      _vm.combinationJobDialog,
                      "gridParams",
                      $event
                    )
                  },
                  gridReady: function(params) {
                    return (_vm.combinationJobDialog.gridApi = params.api)
                  }
                }
              }),
              _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.confirmCombinationJob }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.combinationJobDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.easSyncDialog.visible,
            title: _vm.$t("SeaExport.BatchSend") + "EAS",
            width: "1000px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.easSyncDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                "flex-grow": "1",
                display: "flex",
                "flex-direction": "column",
                "text-align": "center"
              }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-position": "left", "label-width": "90px" } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.AccountObject")
                              }
                            },
                            [
                              _c("cargo-company-select", {
                                attrs: {
                                  "method-params": { active: true },
                                  "check-credit": false,
                                  "default-value":
                                    _vm.easSyncDialog.accountId || ""
                                },
                                on: {
                                  change: function(p) {
                                    _vm.easSyncDialog.accountId = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("SeaExport.Currency") } },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Currency,
                                  "default-value":
                                    _vm.easSyncDialog.currency || "",
                                  "options-width": "100px"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.easSyncDialog.currency = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label:
                                  "EAS" + _vm.$t("CargoMsg.Cargo_ChargeStatus")
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    clearable: true,
                                    placeholder: _vm.$t(
                                      "SeaExport.PleaseSelect"
                                    ),
                                    size: "mini"
                                  },
                                  model: {
                                    value: _vm.easSyncDialog.easChargeState,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.easSyncDialog,
                                        "easChargeState",
                                        $$v
                                      )
                                    },
                                    expression: "easSyncDialog.easChargeState"
                                  }
                                },
                                _vm._l(
                                  _vm.ChargeConstants.EAS_CHARGE_STATES,
                                  function(item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label:
                                          _vm.$store.getters.language === "zh"
                                            ? item.chineseName
                                            : item.englishName,
                                        value: item.code
                                      }
                                    })
                                  }
                                ),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 3 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { "label-width": "0" } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.searchChargeHandler }
                                },
                                [_vm._v(_vm._s(_vm.$t("common.btn.query")))]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("cargo-ag-grid", {
            staticStyle: { "margin-top": "10px", height: "400px" },
            attrs: {
              "config-module": "1300011",
              "grid-options": _vm.easSyncDialog.gridOptions,
              "column-defs": _vm.easSyncDialog.columnDefs,
              "row-data": _vm.easSyncDialog.rowData,
              "grid-params": _vm.easSyncDialog.gridParams,
              "check-main-record": false,
              "deselect-main-record": false
            },
            on: {
              "update:gridParams": function($event) {
                return _vm.$set(_vm.easSyncDialog, "gridParams", $event)
              },
              "update:grid-params": function($event) {
                return _vm.$set(_vm.easSyncDialog, "gridParams", $event)
              },
              gridReady: function(params) {
                return (_vm.easSyncDialog.gridApi = params.api)
              }
            }
          }),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("span", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.selectEasSyncDialog.length > 0,
                    expression: "selectEasSyncDialog.length>0"
                  }
                ],
                domProps: { textContent: _vm._s(_vm.selectionCountLabel) }
              }),
              this.reCalc
                ? _c("charge-currency-total-group", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.totalTyep === "ar",
                        expression: "totalTyep === 'ar'"
                      }
                    ],
                    key: 1,
                    attrs: {
                      "data-field": "amount",
                      "amount-to-currency": _vm.localCurrency,
                      mode: "group",
                      "is-gross-profit": true,
                      "data-provider": _vm.selectEasSyncDialog,
                      source: _vm.viewSource,
                      type: "ar"
                    }
                  })
                : _vm._e(),
              this.reCalc
                ? _c("charge-currency-total-group", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.totalTyep === "ap",
                        expression: "totalTyep === 'ap'"
                      }
                    ],
                    key: 2,
                    attrs: {
                      "data-field": "amount",
                      "amount-to-currency": _vm.localCurrency,
                      mode: "group",
                      "is-gross-profit": true,
                      "data-provider": _vm.selectEasSyncDialog,
                      source: _vm.viewSource,
                      type: "ap"
                    }
                  })
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmEasSync }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c("el-button", { on: { click: _vm.closeEasSyncDialog } }, [
                _vm._v(_vm._s(_vm.$t("common.btn.cancel")))
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm.podInfo.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.podInfo.visible,
                title: _vm.$t(
                  "SeaExport.BatchModifyDestinationPortInformation"
                ),
                width: "700px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.podInfo, "visible", $event)
                }
              }
            },
            [
              _c(
                "div",
                { staticStyle: { display: "flex", flex: "1" } },
                [
                  _c(
                    "el-form",
                    {
                      staticStyle: { "padding-right": "20px" },
                      attrs: {
                        "label-width": "120px",
                        "label-position": "left"
                      }
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    title: _vm.$t(
                                      "SeaExport.OverseasWarehouseNonAmazonWarehouse"
                                    ),
                                    label: _vm.$t(
                                      "SeaExport.EstimatedDeliveryToWarehouseTime"
                                    )
                                  }
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      no: "45",
                                      type: "datetime",
                                      "value-format": "yyyy-MM-dd HH:mm:ss",
                                      format: "yyyy-MM-dd HH:mm"
                                    },
                                    model: {
                                      value:
                                        _vm.podInfo
                                          .estimatedDeliveryToWarehouseTime,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.podInfo,
                                          "estimatedDeliveryToWarehouseTime",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "podInfo.estimatedDeliveryToWarehouseTime"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    title: _vm.$t(
                                      "SeaExport.OverseasWarehouseNonAmazonWarehouse"
                                    ),
                                    label: _vm.$t(
                                      "SeaExport.ActualDeliveryToWarehouseTime"
                                    )
                                  }
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      no: "46",
                                      type: "datetime",
                                      "value-format": "yyyy-MM-dd HH:mm:ss",
                                      format: "yyyy-MM-dd HH:mm"
                                    },
                                    model: {
                                      value: _vm.podInfo.deliveryTime,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.podInfo,
                                          "deliveryTime",
                                          $$v
                                        )
                                      },
                                      expression: "podInfo.deliveryTime"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SeaExport.EstimatedDeliveryToCustomersWarehouseTime"
                                    )
                                  }
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      no: "47",
                                      type: "datetime",
                                      "value-format": "yyyy-MM-dd HH:mm:ss",
                                      format: "yyyy-MM-dd HH:mm"
                                    },
                                    model: {
                                      value: _vm.podInfo.destPortDeliveryTime,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.podInfo,
                                          "destPortDeliveryTime",
                                          $$v
                                        )
                                      },
                                      expression: "podInfo.destPortDeliveryTime"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SeaExport.ActualDeliveryToCustomersWarehouseTime"
                                    )
                                  }
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      no: "48",
                                      type: "datetime",
                                      "value-format": "yyyy-MM-dd HH:mm:ss",
                                      format: "yyyy-MM-dd HH:mm"
                                    },
                                    model: {
                                      value: _vm.podInfo.deliveryCompletionDate,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.podInfo,
                                          "deliveryCompletionDate",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "podInfo.deliveryCompletionDate"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SeaExport.EstimatedDeliveryTime"
                                    )
                                  }
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      no: "49",
                                      type: "datetime",
                                      "value-format": "yyyy-MM-dd HH:mm:ss",
                                      format: "yyyy-MM-dd HH:mm"
                                    },
                                    model: {
                                      value: _vm.podInfo.estDeliveryTime,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.podInfo,
                                          "estDeliveryTime",
                                          $$v
                                        )
                                      },
                                      expression: "podInfo.estDeliveryTime"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SeaExport.ActualDeliveryTime"
                                    )
                                  }
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      no: "50",
                                      type: "datetime",
                                      "value-format": "yyyy-MM-dd HH:mm:ss",
                                      format: "yyyy-MM-dd HH:mm"
                                    },
                                    model: {
                                      value: _vm.podInfo.actDeliveryTime,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.podInfo,
                                          "actDeliveryTime",
                                          $$v
                                        )
                                      },
                                      expression: "podInfo.actDeliveryTime"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SeaExport.EstimatedReturnTime"
                                    )
                                  }
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      no: "51",
                                      type: "datetime",
                                      "value-format": "yyyy-MM-dd HH:mm:ss",
                                      format: "yyyy-MM-dd HH:mm"
                                    },
                                    model: {
                                      value: _vm.podInfo.estimatedReturnTime,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.podInfo,
                                          "estimatedReturnTime",
                                          $$v
                                        )
                                      },
                                      expression: "podInfo.estimatedReturnTime"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.ActualReturnTime")
                                  }
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      no: "52",
                                      type: "datetime",
                                      "value-format": "yyyy-MM-dd HH:mm:ss",
                                      format: "yyyy-MM-dd HH:mm"
                                    },
                                    model: {
                                      value: _vm.podInfo.destPortReturnTime,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.podInfo,
                                          "destPortReturnTime",
                                          $$v
                                        )
                                      },
                                      expression: "podInfo.destPortReturnTime"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.confirmBatchModifyPodInfo()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.podInfo.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _c("lts-batch-sync", {
        ref: "ltsBatchSyncCharge",
        attrs: { visible: _vm.ltsWindow.visible, keys: _vm.ltsWindow.keys },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.ltsWindow, "visible", $event)
          }
        }
      }),
      _c("batch-modify-business-dialog", {
        attrs: {
          visible: _vm.batchModifyBusinessDialog.visible,
          "job-keys": _vm.batchModifyBusinessDialog.jobKeys,
          "job-list": _vm.batchModifyBusinessDialog.jobList,
          lob: _vm.batchModifyBusinessDialog.lob
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.batchModifyBusinessDialog, "visible", $event)
          },
          callback: _vm.batchModifyBusinessCallback
        }
      }),
      _c("batch-submit-or-approve-dialog", {
        attrs: {
          visible: _vm.batchSubmitOrApproveDialog.visible,
          "row-data": _vm.batchSubmitOrApproveDialog.rowData,
          "is-submit": true
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.batchSubmitOrApproveDialog, "visible", $event)
          }
        }
      }),
      _c("change-sop-template-dialog", {
        attrs: {
          visible: _vm.changeSopTemplateDialog.visible,
          lob: _vm.lob,
          "job-list": _vm.changeSopTemplateDialog.jobList
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.changeSopTemplateDialog, "visible", $event)
          },
          reload: _vm.reload
        }
      }),
      _c("batch-cooperation-dialog", {
        attrs: {
          visible: _vm.batchCooperationDialog.visible,
          "job-list": _vm.batchCooperationDialog.jobList,
          "order-center-branch": _vm.orderCenterBranch
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.batchCooperationDialog, "visible", $event)
          }
        }
      }),
      _c("download-import-template-dialog", {
        attrs: {
          visible: _vm.downloadImportTemplateDialog.visible,
          lob: _vm.downloadImportTemplateDialog.lob
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.downloadImportTemplateDialog, "visible", $event)
          }
        }
      }),
      _vm.workFlowApplyDialog.visible
        ? _c("job-work-flow-apply-dialog", {
            attrs: {
              visible: _vm.workFlowApplyDialog.visible,
              title: _vm.$t("CargoMsg.Cargo_Approving"),
              "process-info": _vm.workFlowApplyDialog.documentProcess,
              records: _vm.workFlowApplyDialog.approvalCommentsRecords,
              type: "approve",
              "doc-id": _vm.workFlowApplyDialog.documentProcess.docId,
              "document-config-id":
                _vm.workFlowApplyDialog.documentProcess.documentConfigId
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.workFlowApplyDialog, "visible", $event)
              },
              close: function($event) {
                _vm.workFlowApplyDialog.visible = false
              },
              closeAndRefresh: function() {
                _vm.workFlowApplyDialog.visible = false
                _vm.toQuery()
              }
            }
          })
        : _vm._e(),
      _vm.gpExplain.visible
        ? _c("add-gp-explain-dialog", {
            attrs: {
              type: _vm.gpExplain.type,
              visible: _vm.gpExplain.visible,
              "job-uuids": _vm.gpExplain.jobUuids
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.gpExplain, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _c("booking-fail-dialog", {
        attrs: {
          visible: _vm.bookingFailDialog.visible,
          "select-data": _vm.bookingFailDialog.selectData
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.bookingFailDialog, "visible", $event)
          },
          refresh: function($event) {
            return _vm.toQuery()
          }
        }
      }),
      _c("job-return-review-dialog", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.returnReviewDialog.visible,
            expression: "returnReviewDialog.visible"
          }
        ],
        attrs: {
          visible: _vm.returnReviewDialog.visible,
          lob: "SE",
          "selected-jobs": _vm.returnReviewDialog.selectedJobs,
          srouce: "list"
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.returnReviewDialog, "visible", $event)
          },
          confirm: _vm.toQuery
        }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.chargeTypeDialog.visible,
            title: _vm.$t("CargoMsg.Cargo_AddCostType"),
            width: "400px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.chargeTypeDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { margin: "30px 30px" } },
            [
              _c(
                "el-radio-group",
                {
                  attrs: { size: "small" },
                  model: {
                    value: _vm.chargeTypeDialog.type,
                    callback: function($$v) {
                      _vm.$set(_vm.chargeTypeDialog, "type", $$v)
                    },
                    expression: "chargeTypeDialog.type"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [
                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Receivable")))
                  ]),
                  _c("el-radio", { attrs: { label: 2 } }, [
                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Dues")))
                  ]),
                  _c("el-radio", { attrs: { label: 0 } }, [
                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ARAP")))
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onChargeTypeDialogConfirm }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.chargeTypeDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c("batch-export-to-import-window", { ref: "batchExportToImportWindow" }),
      _c("custom-form-window", {
        ref: "customFormWindow",
        on: { instructionCallback: _vm.onInstructionCallback }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.batchAssignMblDialog.visible,
            title: _vm.$t("Message.WarmReminder"),
            width: "600px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.batchAssignMblDialog, "visible", $event)
            }
          }
        },
        [
          _c("div", {
            staticStyle: {
              margin: "20px 0px 20px 30px",
              "line-height": "20px",
              "font-size": "14px",
              color: "#333"
            },
            domProps: { innerHTML: _vm._s(_vm.batchAssignMblDialog.message) }
          })
        ]
      ),
      _c("tenant-entrust-window", {
        ref: "tenantEntrustWindow",
        on: { instructionCallback: _vm.onInstructionCallback }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }